import Select, { type SelectOption } from '@widesk-ui/components/form/Select';
import View                          from '@widesk-ui/components/View';
import useDesignTokens               from '@/hooks/useDesignTokens';

/**
 * Un `Select` qui peut être "mixte" (formes sélectionnées pas toutes d'accord) — ne jamais passer
 * la valeur réelle à `Select` en mode mixte : une valeur vide (`''`) correspond souvent à une
 * option existante de la liste (ex. "Aucune"), le `Select` (Antd) afficherait alors son libellé au
 * lieu du placeholder "Valeurs différentes" voulu ici. Seul `undefined` ne correspond à aucune
 * option et laisse réellement apparaître le placeholder — même piège que celui documenté dans
 * `TriStateSwitch` pour `Switch`, ici pour `Select`. L'habillage visuel (bordure pointillée, même
 * convention que `TriStateSwitch`) suit uniquement `mixed`, jamais la valeur elle-même.
 */
export default function MixedSelect({ value, mixed, onChange, options, placeholder }: {
	value: unknown;
	mixed?: boolean;
	onChange: (value: unknown) => void;
	options: SelectOption[];
	placeholder?: string;
}) {
	const tokens = useDesignTokens();

	if (!mixed) return <Select value={value} onChange={onChange} options={options} placeholder={placeholder} />;

	return (
		<View
			br={8}
			p={2}
			style={{ border: `1.5px dashed ${tokens.color.primary}` }}
		>
			<Select value={undefined} onChange={onChange} options={options} placeholder="Valeurs différentes" />
		</View>
	);
}
